import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as Action from "../../../applicant/_redux/applicantActions";
import { TextArea } from "../../../../../_metronic/_partials/controls/forms/TextArea";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import { swalError, swalSuccess } from "../../../../helpers/swal";
import { Input, Tag } from "antd";

const _init = {
  career_summary: "",
  preferred_industries: [],
  hobbies: [],
  interest: [],
  is_fresher: 0,
};

const CareerObjective = ({ id }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(_init);
  const [hobbiesValue, setHobbiesValue] = useState("");
  const [selectedHobbies, setSelectedHobbies] = useState([]);
  const [interestValue, setInterestValue] = useState("");
  const [selectedInterest, setSelectedInterest] = useState([]);
  const [industriesValue, setIndustriesValue] = useState("");
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [isChecked, setIsChecked] = useState(false);

  const { applicantsInfo } = useSelector(
    ({ applicant }) => ({
      applicantsInfo: applicant.applicantsInfo,
    }),
    shallowEqual
  );

  const validationSchema = Yup.object().shape({
    career_summary: Yup.string()
      .nullable()
      .required("Career Summary is required"),
  });

  const handleSaveProfile = async (values) => {
    // const formData = new FormData()
    // for(let key of Object.keys(values)){
    //     formData.append(key, values[key])
    // }

    values.interest =
      selectedInterest?.length > 0 ? JSON.stringify(selectedInterest) : "";
    values.hobbies =
      selectedHobbies?.length > 0 ? JSON.stringify(selectedHobbies) : "";
    values.preferred_industries =
      selectedIndustries?.length > 0 ? JSON.stringify(selectedIndustries) : "";
    values.is_fresher = values?.is_fresher ? 1 : 0;

    const response = await API.patch(
      "hrms_applicant/update-career-objective/" + id,
      values
    );
    if (response.data.success) {
      swalSuccess(response.data.message);
      dispatch(
        Action.createProfileScore(
          {
            name: ["Career Summary"],
            applicant_id: id,
          },
          () => {
            dispatch(Action.getApplicantPersonalInfo(id));
            fetchData();
          }
        )
      );
    } else {
      swalError(response.data.message);
    }
  };
  const fetchData = async () => {
    const response = await API.get("hrms_applicant/get-objective/" + id);
    if (response.data.success) {
      if (Object.keys(response.data.data).length) {
        setProfile({ career_summary: response.data.data.career_summary });
      }
    } else {
      swalError(response.data.message);
    }
  };

  const handleCheckForeignDegree = (val, values, setFieldValue) => {
    setIsChecked(!isChecked);
    if (val) {
      setFieldValue("is_fresher", !isChecked ? 1 : 0);
      dispatch(
        Action.createProfileScore(
          {
            name: ["Career Summary"],
            applicant_id: id,
          },
          () => {
            dispatch(Action.getApplicantPersonalInfo(id));
            fetchData();
          }
        )
      );
    } else {
      setFieldValue("is_fresher", 0);
      dispatch(
        Action.updateProfileScore(
          {
            name: ["Career Summary"],
            applicant_id: id,
          },
          () => {
            dispatch(Action.getApplicantPersonalInfo(id));
            fetchData();
          }
        )
      );
    }
  };

  const handleInputChange = (value, type) => {
    if (type == "hobby") {
      setHobbiesValue(value);
    } else if (type == "industry") {
      setIndustriesValue(value);
    } else {
      setInterestValue(value);
    }
  };

  const handleKeyPress = (e, type) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (type == "hobby") {
        const newSkill = hobbiesValue.trim();
        if (newSkill && !selectedHobbies.includes(newSkill)) {
          setSelectedHobbies([...selectedHobbies, newSkill]);
          setHobbiesValue("");
        }
      } else if (type == "industry") {
        const newIndustry = industriesValue.trim();
        if (newIndustry && !selectedIndustries.includes(newIndustry)) {
          setSelectedIndustries([...selectedIndustries, newIndustry]);
          setIndustriesValue("");
        }
      } else {
        const newValue = interestValue.trim();
        if (newValue && !selectedInterest.includes(newValue)) {
          setSelectedInterest([...selectedInterest, newValue]);
          setInterestValue("");
        }
      }
    }
  };

  const handleSkillRemove = (skillToRemove, type) => {
    if (type == "hobby") {
      setSelectedHobbies(
        selectedHobbies.filter((skill) => skill !== skillToRemove)
      );
    } else if (type == "industry") {
      setSelectedIndustries(
        selectedIndustries.filter((skill) => skill !== skillToRemove)
      );
    } else {
      setSelectedInterest(
        selectedInterest.filter((skill) => skill !== skillToRemove)
      );
    }
  };

  const hobbiesArr =
    applicantsInfo?.hobbies && JSON.parse(applicantsInfo?.hobbies);
  const hobbiesString = hobbiesArr?.length > 0 && hobbiesArr?.join(", ");
  const interestArr =
    applicantsInfo?.interest && JSON.parse(applicantsInfo?.interest);
  const interestString = interestArr?.length > 0 && interestArr?.join(", ");
  const industryArr =
    applicantsInfo?.preferred_industries &&
    JSON.parse(applicantsInfo?.preferred_industries);
  const industryString = industryArr?.length > 0 && industryArr?.join(", ");

  useEffect(() => {
    const hobbiesData = applicantsInfo?.hobbies
      ? JSON.parse(applicantsInfo?.hobbies)
      : [];
    const interestData = applicantsInfo?.interest
      ? JSON.parse(applicantsInfo?.interest)
      : [];
    const industriesData = applicantsInfo?.preferred_industries
      ? JSON.parse(applicantsInfo?.preferred_industries)
      : [];
    setProfile({
      career_summary: applicantsInfo?.career_summary,
      preferred_industries: industriesData,
      hobbies: hobbiesData,
      interest: interestData,
      is_fresher:
        (applicantsInfo?.is_fresher === 0 && false) ||
        (applicantsInfo?.is_fresher === 1 && true),
    });
    setIsChecked(
      (applicantsInfo?.is_fresher === 0 && false) ||
        (applicantsInfo?.is_fresher === 1 && true)
    );
    setSelectedInterest(interestData);
    setSelectedIndustries(industriesData);
    setSelectedHobbies(hobbiesData);
  }, [applicantsInfo]);

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  useEffect(() => {
    dispatch(Action.getApplicantsInfoById(id));
  }, [id]);

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={profile}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSaveProfile(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Career Summary and Objective</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <div className="career_summary_main_div">
                      <TextArea
                        label={"Career Summary and Objective"}
                        isRequired
                        value={values.career_summary}
                        onChange={(e) => {
                          setFieldValue("career_summary", e.target.value);
                        }}
                      />

                      {errors.career_summary && touched.career_summary && (
                        <div className="text-danger">
                          {errors.career_summary}
                        </div>
                      )}
                    </div>

                    <hr />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="">
                      <b>Skills</b>
                    </label>
                    <Input
                      value={hobbiesValue}
                      onChange={(e) => {
                        handleInputChange(e.target.value, "hobby");
                      }}
                      onKeyPress={(e) => handleKeyPress(e, "hobby")}
                      placeholder="Type a Skills and press Enter"
                    />
                    <div style={{ marginTop: 10 }}>
                      {selectedHobbies.map((skill) => (
                        <Tag
                          key={skill}
                          closable
                          onClose={() => handleSkillRemove(skill, "hobby")}
                        >
                          {skill}
                        </Tag>
                      ))}
                    </div>
                    {errors.hobbies && touched.hobbies ? (
                      <div className="text-danger">{errors.hobbies}</div>
                    ) : null}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="">
                      <b>Hobbies and Interest</b>
                    </label>
                    <Input
                      value={interestValue}
                      onChange={(e) => {
                        handleInputChange(e.target.value, "interest");
                      }}
                      onKeyPress={(e) => handleKeyPress(e, "interest")}
                      placeholder="Type a Hobbies/interests and press Enter"
                    />
                    <div style={{ marginTop: 10 }}>
                      {selectedInterest.map((skill) => (
                        <Tag
                          key={skill}
                          closable
                          onClose={() => handleSkillRemove(skill, "interest")}
                        >
                          {skill}
                        </Tag>
                      ))}
                    </div>
                    {errors.interest && touched.interest ? (
                      <div className="text-danger">{errors.interest}</div>
                    ) : null}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="">
                      <b>Preferred Industries</b>
                    </label>

                    <Input
                      value={industriesValue}
                      onChange={(e) => {
                        handleInputChange(e.target.value, "industry");
                      }}
                      onKeyPress={(e) => handleKeyPress(e, "industry")}
                      placeholder="Type a industry and press Enter"
                    />
                    <div style={{ marginTop: 10 }}>
                      {selectedIndustries.map((skill) => (
                        <Tag
                          key={skill}
                          closable
                          onClose={() => handleSkillRemove(skill, "industry")}
                        >
                          {skill}
                        </Tag>
                      ))}
                    </div>
                    {errors.preferred_industries &&
                    touched.preferred_industries ? (
                      <div className="text-danger">
                        {errors.preferred_industries}
                      </div>
                    ) : null}
                  </div>

                  {/* <div className="col-md-4 mt-4 mb-3">
                                        <Field
                                            type="checkbox"
                                            checked={isChecked}
                                            id="is_fresher"
                                            onChange={(e) => handleCheckForeignDegree(e.target.checked, values, setFieldValue)}
                                        />
                                        <label className="form-check-label ml-2" htmlFor="is_fresher"><b>Are You Fresher?</b></label>
                                    </div> */}
                </div>
              </div>
            </div>

            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CareerObjective;
